module.exports = __webpack_public_path__ + "img/ico_morentouxiang.936fe897.svg";